<h1>{{'Erreur 500, 409, 34034, 12' | transloco}}</h1>
<p class="margin-bottom-50">{{'Bref, il y a une erreur de notre cote mais ca ne sert a rien de vous dire laquelle c\'est. Dans tous les cas, pouvez-vous repasser apres un cafe ?' | transloco}}</p>
<!-- <div class="xs-align-center">
    <a href="http://www.ameriquedusud.org/article-le-cafe-mexicain-une-boisson-qui-fait-partie-de-la-culture-locale/"
       mat-raised-button
       class="mat-elevation-z"
       color="primary">
         'decouvrir le cafe au mexique' | transloco
    </a>
</div> -->
